module.exports = [
  '쿼카',
  '악어',
  '기린',
  '코끼리',
  '오리',
  '오리너구리',
  '너구리',
  '호랑이',
  '사자',
  '휴먼',
  '토끼',
  '강아지',
  '고양이',
  '원숭이',
  '침팬지',
  '홍학',
  '가마우지',
  '고릴라',
  '카멜레온',
  '앵무새',
  '달팽이',
  '구렁이',
  '이무기',
  '얼룩말',
  '용',
  '유니콘',
  '불사조',
  '디멘터',
  '하이에나',
  '코뿔소',
  '맘모스',
  '하마',
  '티라노사우르스',
  '랩터',
  '브라키오사우르스',
  '햄스터',
  '치타',
  '익룡',
  '멧돼지',
  '산돼지',
  '돼지',
  '피글렛',
  '캥거루',
  '산토끼',
  '쥐',
  '기니피그',
  '시골쥐',
  '도시쥐',
  '두루미',
  '여우',
  '패럿',
  '늑대',
  '수달',
  '늑대인간',
  '북극곰',
  '곰',
  '반달가슴곰',
  '펭귄',
  '남극곰',
  '거미',
  '밍크',
  '족제비',
  '소',
  '부엉이',
  '올빼미',
  '뱀',
  '코브라',
  '아나콘다',
  '킹코브라',
  '담비',
  '타조',
  '북극여우',
  '독수리',
  '알바트로스',
  '오랑우탄',
  '물범',
  '코알라',
  '하프물범',
  '북극토끼',
  '고래',
  '상어',
  '칠면조',
  '코뿔바다오리',
  '직박구리',
  '황제펭귄',
  '물개',
  '고슴도치',
  '두더지',
  '판다',
  '랫서판다',
  '돌고래',
  '범고래',
  '고래',
  '식인고래',
  '개구리',
  '사슴',
  '물소',
  '맹꽁이',
  '우파루파',
  '이구아나',
  '염소',
  '노새',
  '당나귀',
  '올챙이',
  '병아리',
  '살모사',
  '하늘다람쥐',
  '도롱뇽',
  '퓨마',
  '아르마딜로',
  '미어캣',
  '다람쥐',
  '알파카',
  '일본자이언트날다람쥐',
  '포메라니안',
  '진돗개',
  '웰시코기',
  '말티즈',
  '시베리안 허스키',
  '닥스훈트',
  '리트리버',
  '노르웨이숲',
  '푸들',
  '낙타',
  '스피츠',
  '삽살개',
  '먼치킨',
  '페르시안 고양이',
  '래그돌',
  '스코티쉬 폴드',
  '러시안 블루',
  '닭',
  '공작새',
  '쥐며느리',
  '키위새',
  '장수하늘소',
  '흰긴수염고래',
  '죠스',
  '식인상어',
  '아기상어',
  '황금들창코원숭이',
  '긴꼬리원숭이',
  '안경원숭이',
  '자라',
  '표범',
  '청설모',
  '바비루사',
  '빅풋',
  '예티',
  '알락꼬리여우원숭이',
  '메추라기',
  '스라소니',
  '삵',
  '오소리',
  '백조',
  '까치',
  '카피바라',
  '라마',
  '딱따구리',
  '기러기',
  '스컹크',
  '비둘기',
  '봉황',
  '해태',
  '구미호',
  '인면조',
  '개미핥기',
  '대왕오징어',
  '갑오징어',
  '두억시니',
  '샐러맨더',
  '바실리스크',
  '와이번',
];
